import { useContext } from 'react';

import { MapContext } from '../contexts/map/context';
import { MapContextProps } from '../contexts/map/types';

export function useMap(): MapContextProps {
    return useContext(MapContext);
}
